import { GridSize } from '@mui/material';
import { useEffect, useState } from 'react';

export const useGetPlaybackWidth = (
  drawerOpen: boolean,
  filtersOpen: boolean,
  multiActive: boolean
) => {
  const [width, setWidth] = useState<GridSize>(8);
  useEffect(() => {
    const getWidth = () => {
      if (window && window.innerWidth > 1700) {
        if (!filtersOpen) {
          if (!multiActive) {
            if (drawerOpen) setWidth(8);
            else setWidth(8);
          } else {
            if (drawerOpen) setWidth(9);
            else setWidth(11);
          }
        } else {
          if (!multiActive) {
            if (drawerOpen) setWidth(7);
            else setWidth(7);
          } else {
            if (drawerOpen) setWidth(8);
            else setWidth(11);
          }
        }
      } else if (window && window.innerWidth > 1400) {
        if (!filtersOpen) {
          if (!multiActive) {
            if (drawerOpen) setWidth(7);
            else setWidth(7);
          } else {
            if (drawerOpen) setWidth(9);
            else setWidth(12);
          }
        } else {
          if (!multiActive) {
            if (drawerOpen) setWidth(6);
            else setWidth(6);
          } else {
            if (drawerOpen) setWidth(9);
            else setWidth(10);
          }
        }
      } else if (window && window.innerWidth > 1200) {
        if (!filtersOpen) {
          if (!multiActive) {
            if (drawerOpen) setWidth(7);
            else setWidth(7);
          } else {
            if (drawerOpen) setWidth(9);
            else setWidth(12);
          }
        } else {
          if (!multiActive) {
            if (drawerOpen) setWidth(6);
            else setWidth(6);
          } else {
            if (drawerOpen) setWidth(9);
            else setWidth(9);
          }
        }
      } else if (window && window.innerWidth > 1000) {
        if (!filtersOpen) {
          if (drawerOpen) setWidth(7);
          else setWidth(7);
        } else {
          if (!multiActive) {
            if (drawerOpen) setWidth(6);
            else setWidth(6);
          } else {
            if (drawerOpen) setWidth(8);
            else setWidth(8);
          }
        }
      } else if (window) {
        if (!multiActive) {
          if (drawerOpen) setWidth(6);
          else setWidth(7);
        } else {
          if (drawerOpen) setWidth(6);
          else setWidth(12);
        }
      } else {
        setWidth(8);
      }
    };
    getWidth();
    if (window) window.addEventListener('resize', getWidth);
    return () => window.removeEventListener('resize', getWidth);
  }, [drawerOpen, filtersOpen, multiActive]);
  return width;
};
